import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for subscription
export const subscribeWithTeacher = createAsyncThunk(
  'subscription/subscribeWithTeacher',
  async (subscriptionData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");

      const response = await fetch(`${BASE_URL}/teacher/supscription_with_teacher`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(subscriptionData),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || 'حدث خطأ في الاشتراك');
      }

      return data;
    } catch (error) {
      return rejectWithValue('حدث خطأ في الاتصال');
    }
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    isSubscribing: false,
    subscriptionError: null,
    subscriptionSuccess: null,
    paymentUrl: null,
  },
  reducers: {
    clearSubscriptionError: (state) => {
      state.subscriptionError = null;
    },
    clearSubscriptionSuccess: (state) => {
      state.subscriptionSuccess = null;
      state.paymentUrl = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeWithTeacher.pending, (state) => {
        state.isSubscribing = true;
        state.subscriptionError = null;
        state.subscriptionSuccess = null;
        state.paymentUrl = null;
      })
      .addCase(subscribeWithTeacher.fulfilled, (state, action) => {
        state.isSubscribing = false;
        state.subscriptionSuccess = action.payload.message || 'تم إنشاء الاشتراك بنجاح';
        state.paymentUrl = action.payload.result;
      })
      .addCase(subscribeWithTeacher.rejected, (state, action) => {
        state.isSubscribing = false;
        state.subscriptionError = action.payload;
      });
  },
});

export const { clearSubscriptionError, clearSubscriptionSuccess } = subscriptionSlice.actions;
export default subscriptionSlice.reducer; 